export default __webpack_public_path__ + "static/media/voltaware-crm-logo.284a5000.svg";